import React, { useState } from 'react'
import './encounterList.css'
const EncounterList = ({mappedConditions,setconditionKey,active,setactive}) => {
    const [currentIndex, setcurrentIndex] = useState("")

  return (
    <div className='conditionList'>
      <span className={`conditionKey ${active?"active":""}`} onClick={()=>{
        setactive(true)
        setcurrentIndex("")
      }}>
         All Conditions
      </span>
        {mappedConditions.map((item,idx)=>(
          
            <span className={`conditionKey ${currentIndex===idx?"active":""}`} key={idx} onClick={()=>{
              setconditionKey(item.conditionType)
              setcurrentIndex(idx)
              setactive(false)
            }}>
                    {item.conditionType}
            </span>
          
        ))}
    </div>
  )
}

export default EncounterList